import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Grid from 'apollo-react/components/Grid';
import React, { useState } from 'react';

import SavedSearchesTable from '../../../components/SavedSearchesTable';
import MultiSelectCell from '../../../components/TableSelect/MultiSelectCell';
import { selectAllHeader } from '../../../components/TableSelect/MultiSelectHeader';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { removeCurrentPageSelection } from '../../../utils/commonUtils';
import {
  DETAILS_TABLE_SAVED_SEARCHES_NAME,
  DETAILS_TABLE_TITLE,
  PACKAGES_DETAIL_TABLE_ENTITY_NAME,
  PACKAGES_TABLE_ENTITY_NAME,
  PACKAGES_TABLE_SAVED_SEARCHES_NAME,
  PACKAGES_TABLE_TITLE,
} from '../../constants/export.constants';
import PackageDetailsDialog from '../controls/PackageDetailsDialog';

const useStyles = makeStyles({
  zoomDialogPaperFullWidth: {
    maxWidth: '90%',
  },
  muiDialogContent: {
    '& [class*="MuiDialogContent"]': {
      maxWidth: 'unset',
    },
    '& [class*="MuiDialogActions"]': {
      marginBottom: 20,
      marginTop: 5,
    },
  },
  link: {
    textDecoration: 'none',
    color: '#06C !important',
    lineHeight: 1.5,
    fontFamily: 'Proxima Nova, Noto Sans, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    '&:hover': {
      color: '#06C !important',
    },
  },
  savedSearchContainer: {
    '& thead > tr > th:nth-child(1) > svg': {
      display: 'none !important',
    },
  },
});

const PackagesTable = ({ handleUpdatePackages, selectedPackages }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [packageId, setPackageId] = useState(null);
  const [selections, setSelections] = useState(selectedPackages);

  const handleMultiSelect = (checked, row) => {
    const newSelections = checked
      ? [...selections, row]
      : selections.filter((s) =>
          Boolean(row.PrimaryKeyColumn) && Boolean(s.PrimaryKeyColumn)
            ? s[s.PrimaryKeyColumn] !== row[row.PrimaryKeyColumn]
            : JSON.stringify(s) !== JSON.stringify(row)
        );

    setSelections(newSelections);
    handleUpdatePackages({ packages: newSelections });
  };

  const handleHeaderMultiselect = (
    allRowsPerPage,
    isAllRecordsPerPageSelected,
    isSelectedRecordOnCurrentPage
  ) => {
    if (
      (isSelectedRecordOnCurrentPage && !isAllRecordsPerPageSelected) ||
      isAllRecordsPerPageSelected
    ) {
      const filteredSelections = removeCurrentPageSelection(allRowsPerPage, selections);
      setSelections(filteredSelections);
      handleUpdatePackages({ packages: filteredSelections });
      return;
    }

    setSelections([...selections, ...allRowsPerPage]);
    handleUpdatePackages({ packages: [...selections, ...allRowsPerPage] });
  };

  const onClickDetails = (row) => {
    setPackageId(row.PK_ID);
    setDetailsDialogOpen(true);
  };

  const extraColumns = [
    {
      header: (rows) => selectAllHeader(rows, handleHeaderMultiselect, selections),
      accessor: 'SELECT_ALL_HEADER',
      customCell: MultiSelectCell(selections, handleMultiSelect),
      fixedWidth: true,
      width: 20,
      index: 0,
    },
    {
      index: 8,
      accessor: '',
      header: '',
      fixedWidth: true,
      width: 50,
      customCell: ({ row }) => {
        return (
          <Button variant="text" size="small" onClick={() => onClickDetails(row)}>
            {translateString('Details')}
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div className={classes.savedSearchContainer}>
            <SavedSearchesTable
              title={translateString(PACKAGES_TABLE_TITLE)}
              entityName={PACKAGES_TABLE_ENTITY_NAME}
              initialSearchName={PACKAGES_TABLE_SAVED_SEARCHES_NAME}
              initialTranslatedSearchName={null}
              dataKey=""
              customFilter={[]}
              referencedColumns={{}}
              dynamicParamCollection={{}}
              rowsPerPageOptions={[10, 25, 50]}
              extraColumns={extraColumns}
              enableSorting
              showSearchSelector={false}
              onSavedSearchChange={() => {}}
              showFilters
            />
          </div>
        </Grid>
      </Grid>

      {detailsDialogOpen && (
        <PackageDetailsDialog
          open={detailsDialogOpen}
          entityName={PACKAGES_DETAIL_TABLE_ENTITY_NAME}
          initialSearchName={DETAILS_TABLE_SAVED_SEARCHES_NAME}
          title={DETAILS_TABLE_TITLE}
          packageId={packageId}
          onClose={() => setDetailsDialogOpen(false)}
        />
      )}
    </>
  );
};

export default PackagesTable;
